var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/lodash/_Symbol.js
// module id = 143
// module chunks = 0